module.exports = __webpack_public_path__ + "img/H000040_paperplane.ae56d9a7.png";